import { api } from './../../api.js';

import axios from 'axios';

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {

	BULK_ORGANIZATION_PROVIDER_CHANGE_STATUS : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.post('admin/bulk/organization/providers/change-status', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	BULK_ORGANIZATION_PROVIDER_DEACTIVATE : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.post('admin/bulk/organization/providers/deactivate', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	BULK_ORGANIZATION_PROVIDER_DELETE : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.delete('admin/bulk/organization/courses/providers/remove', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	BULK_ORGANIZATION_PROVIDER_ADD_TO_PROGRAM : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.post('admin/bulk/organization/providers/add-to-program', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	BULK_ORGANIZATION_PROVIDER_COURSE_ACTIVATE : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.post('admin/bulk/organization/courses/providers/activate', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	BULK_ORGANIZATION_PROVIDER_COURSE_DEACTIVATE : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.post('admin/bulk/organization/courses/providers/deactivate', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	BULK_ORGANIZATION_PROVIDER_COURSE_DUE_DATE : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.post('admin/bulk/organization/courses/providers/due-date', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},
	BULK_ORGANIZATION_PROVIDER_COURSE_START_DATE : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.post('admin/bulk/organization/courses/providers/start-date', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	BULK_ORGANIZATION_PROVIDER_COURSE_APPROVE : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.post('admin/bulk/organization/courses/providers/approve', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	BULK_ORGANIZATION_PROVIDER_COURSE_MESSAGE : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.post('admin/bulk/organization/courses/providers/message', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	BULK_ORGANIZATION_PROVIDER_COURSE_CERTIFICATE : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.post('admin/bulk/organization/courses/providers/certificate', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	BULK_ORGANIZATION_PROVIDER_COURSE_CERTIFICATE_SEND : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.post('admin/bulk/organization/courses/providers/certificate/send', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	}
}

export default {
	state,
	actions,
	getters,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/BulkActionModule.js